import { call, put, SagaReturnType, select } from 'redux-saga/effects';
import * as R from 'remeda';
import { fetchFiles } from 'store/glue/operation/fetchFiles';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as integrationsActions from './actions';
import * as integrationsSelectors from './selectors';

// Reads the currently-selected page from page state (defaults to 1 on first
// load), calls the fetchFiles operation, and writes the returned pagination
// back into page state so the table footer can render totalPages.
export function* startFetchPageSaga(
  action: ActionType<typeof integrationsActions.startFetchPage>,
) {
  function* saga() {
    const currentPagination: ReturnType<
      typeof integrationsSelectors.pagination
    > = yield select(integrationsSelectors.pagination);

    const pageNumber = R.isDefined(currentPagination)
      ? currentPagination.page
      : 1;

    const pagination: SagaReturnType<typeof fetchFiles> = yield call(
      fetchFiles,
      { pageNumber, pageSize: 10 },
    );

    if (!R.isDefined(pagination)) return;

    yield put(integrationsActions.setPagination(pagination));
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
